<template>
  <div id="services">
    <h1 class="page-title">{{ $t('Services.manage_services') }}</h1>

    <div v-if="entities && entities.length > 1">
      <select-entity :entities="entities" :preselectedEntityId="entityId" v-on:entity-changed="onChangeEntityId"></select-entity>
    </div>

    <div v-if="entityId">
      <div v-if='isAdmin && entityHasHubs'>
        <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx">
          <li class="nav-item col-4">
            <a href="#" :class="{ active: true }" data-toggle="tab" data-target="#manage-hubs" aria-expanded="true">
              <span>{{ $t('Services.hubs') }} </span>
            </a>
          </li>
          <li class="nav-item col-4">
            <a href="#" :class="{ active: false }" data-toggle="tab" data-target="#manage-services" class=""
               aria-expanded="false">
              <span>{{ $t('Services.services') }}</span>
            </a>
          </li>
        </ul>
        <div class="tab-content overflow-visible">
          <div class="tab-pane slide-left" :class="{ active: true }" id="manage-hubs" aria-expanded="true">
            <hub-form :entity-id="entityId"></hub-form>
            <hub-table :entity-id="entityId"></hub-table>
          </div>
          <div class="tab-pane slide-left" :class="{ active: false }" id="manage-services" aria-expanded="false">
            <service-hub-form :entity-id="entityId"></service-hub-form>
            <service-hub-container :entity-id="entityId"></service-hub-container>
          </div>
        </div>
      </div>
      <div v-else>
        <service-form :entity-id="entityId"></service-form>
        <service-table :entity-id="entityId"></service-table>
      </div>
    </div>
    <no-data></no-data>
  </div>
</template>

<script>
  import ServiceTable from './ServiceTable'
  import ServiceForm from './ServiceForm'
  import ServiceHubContainer from './ServiceHubContainer'
  import ServiceHubForm from './ServiceHubForm'
  import HubTable from '../hubs/HubTable'
  import HubForm from '../hubs/HubForm'
  import NoData from '../common/NoData'
  import SelectEntity from '../common/SelectEntity'
  import { mapGetters } from 'vuex'
  import { checkRoleAdmin } from '@/helpers/roles'

  export default {
    name: 'Services',
    components: {
      NoData,
      ServiceTable,
      ServiceForm,
      HubTable,
      HubForm,
      ServiceHubContainer,
      ServiceHubForm,
      SelectEntity
    },
    data() {
      return {
        currentEntity: null
      }
    },
    computed: {
      ...mapGetters({
        entities: 'auth/entities',
        entityId: 'auth/currentEntityId',
        currentUser: 'auth/currentUser'
      }),
      isAdmin() {
        return checkRoleAdmin(this.currentUser.role)
      },
      entityHasHubs() {
        if (this.entities && this.entityId) {
          let entitiesHasHubs = this.entities.map(entity => entity.id == this.entityId &&
                                                            entity.hubs != undefined
                                                            && entity.hubs.length > 1)
          return entitiesHasHubs.includes(true)
        }
        return false;
      }
    },
    methods: {
      onChangeEntityId: function(value) {
        if(this.entityId != value.id) {
          this.$store.dispatch('auth/setCurrentEntityId', value.id);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .overflow-visible {
    overflow: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/services/Services.vue